import React, { useState } from 'react';
import { BirthDetails, Gender } from '../types';

interface InputFormProps {
  onSubmit: (details: BirthDetails) => void;
  onInteraction: () => void;
  isLoading: boolean;
}

const InputForm: React.FC<InputFormProps> = ({ onSubmit, onInteraction, isLoading }) => {
  const [details, setDetails] = useState<BirthDetails>({
    date: '1990-01-01',
    time: '12:00',
    gender: Gender.MALE,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(details);
  };

  const handleInteraction = () => {
    onInteraction();
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto bg-slate-800 p-6 rounded-xl border border-slate-700 shadow-2xl">
      <h3 className="text-xl font-bold text-amber-500 mb-6 text-center font-serif tracking-widest">
        輸入生辰
      </h3>

      <div className="space-y-4">
        <div>
          <label className="block text-slate-400 text-sm mb-1">出生日期 (國曆)</label>
          <input
            type="date"
            required
            value={details.date}
            onChange={(e) => {
              setDetails({ ...details, date: e.target.value });
              handleInteraction();
            }}
            onFocus={handleInteraction}
            className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2 text-slate-100 focus:outline-none focus:border-amber-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-slate-400 text-sm mb-1">出生時間</label>
          <input
            type="time"
            required
            value={details.time}
            onChange={(e) => {
              setDetails({ ...details, time: e.target.value });
              handleInteraction();
            }}
            onFocus={handleInteraction}
            className="w-full bg-slate-900 border border-slate-600 rounded px-3 py-2 text-slate-100 focus:outline-none focus:border-amber-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-slate-400 text-sm mb-1">性別</label>
          <div className="flex gap-4">
            <label className={`flex-1 cursor-pointer border rounded px-4 py-2 text-center transition-all ${details.gender === Gender.MALE ? 'bg-amber-900/30 border-amber-500 text-amber-400' : 'bg-slate-900 border-slate-600 text-slate-400'}`}>
              <input
                type="radio"
                name="gender"
                value={Gender.MALE}
                checked={details.gender === Gender.MALE}
                onChange={() => {
                  setDetails({ ...details, gender: Gender.MALE });
                  handleInteraction();
                }}
                className="hidden"
              />
              男 (乾造)
            </label>
            <label className={`flex-1 cursor-pointer border rounded px-4 py-2 text-center transition-all ${details.gender === Gender.FEMALE ? 'bg-amber-900/30 border-amber-500 text-amber-400' : 'bg-slate-900 border-slate-600 text-slate-400'}`}>
              <input
                type="radio"
                name="gender"
                value={Gender.FEMALE}
                checked={details.gender === Gender.FEMALE}
                onChange={() => {
                  setDetails({ ...details, gender: Gender.FEMALE });
                  handleInteraction();
                }}
                className="hidden"
              />
              女 (坤造)
            </label>
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full mt-6 bg-amber-600 hover:bg-amber-500 text-slate-900 font-bold py-3 px-4 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? '推算中...' : '排盤解析'}
        </button>
      </div>
    </form>
  );
};

export default InputForm;
